'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var UgSewerStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('requires further action', Q('requires_further_action'))
;


export default function(incident) {
	UgSewerStateDiagram.updateIncident(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
}
